import { useEffect } from "react";

const BASE_DOMAIN = "https://unrankedagency.com";
const DEFAULT_OG_IMAGE =
  "https://pub-bb2e103a32db4e198524a2e9ed8f35b4.r2.dev/e4c72a30-635c-471a-9920-3372ebcc6e27/id-preview-698e431f--e3195c79-5c5c-469b-846c-046b92475a56.lovable.app-1771265226303.png";

const DEFAULTS = {
  title: "Unranked — Free AI-Powered SEO Audit & Visibility Analysis Tool",
  description:
    "Discover why your website isn't ranking. Get a free, comprehensive SEO audit with AI visibility analysis, backlink intelligence, and a prioritized action plan.",
  canonical: BASE_DOMAIN,
  ogImage: DEFAULT_OG_IMAGE,
};

interface PageMeta {
  title: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
}

function setMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href: string) {
  let el = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function usePageMeta({ title, description, canonical, ogImage }: PageMeta) {
  useEffect(() => {
    document.title = title;

    const desc = description ?? DEFAULTS.description;
    const canon = canonical ?? DEFAULTS.canonical;
    const img = ogImage ?? DEFAULTS.ogImage;

    setMeta("description", desc);
    setMeta("og:title", title, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:url", canon, "property");
    setMeta("og:image", img, "property");
    setMeta("twitter:title", title, "name");
    setMeta("twitter:description", desc, "name");
    setMeta("twitter:image", img, "name");
    setCanonical(canon);

    return () => {
      document.title = DEFAULTS.title;
      setMeta("description", DEFAULTS.description);
      setMeta("og:title", DEFAULTS.title, "property");
      setMeta("og:description", DEFAULTS.description, "property");
      setMeta("og:url", DEFAULTS.canonical, "property");
      setMeta("og:image", DEFAULTS.ogImage, "property");
      setMeta("twitter:title", DEFAULTS.title, "name");
      setMeta("twitter:description", DEFAULTS.description, "name");
      setMeta("twitter:image", DEFAULTS.ogImage, "name");
      setCanonical(DEFAULTS.canonical);
    };
  }, [title, description, canonical, ogImage]);
}
